// src/redux/reducers/discountReducer.js
const initialState = {
    percentage: 20, // Porcentaje de descuento global
    // endTime: null  // Timestamp de fin del descuento
    endTime: new Date("2025-05-26T12:00:00-03:00").getTime() // Ejemplo: 30 de marzo de 2025 a las 15:00 ART
    // endTime: new Date().getTime() + 7 * 24 * 60 * 60 * 1000 // Ejemplo: 7 días a partir de ahora


};

const discountReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_DISCOUNT':
            return {
                ...state,
                percentage: action.payload.percentage,
                endTime: action.payload.endTime
            };
        case 'CLEAR_DISCOUNT':
            return {
                ...state,
                percentage: 0,
                endTime: null
            };
        default:
            return state;
    }
};

export default discountReducer;
